module.exports = __webpack_public_path__ + "img/a1826c6.jpg";